import React from "react";

const formatDate = (iso) => {
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" });
};

const Row = ({ label, value, testId }) => (
  <div className="flex items-center justify-between gap-4 py-3">
    <dt className="text-sm text-[#4A5F52]">{label}</dt>
    <dd className="text-right text-sm font-semibold text-[#111E16]" data-testid={testId}>
      {value}
    </dd>
  </div>
);

export const InviteDetails = ({ data }) => {
  const expires = formatDate(data.expires_at);
  const rows = [
    data.inviter_name && ["Invited by", data.inviter_name, "invite-inviter-name"],
    data.contact_name && ["Invitation for", data.contact_name, "invite-contact-name"],
    data.relationship && ["Relationship", data.relationship, "invite-relationship"],
    expires && ["Valid until", expires, "invite-expires-at"],
  ].filter(Boolean);
  if (!rows.length) return null;
  return (
    <dl
      className="mt-8 divide-y divide-[#E8EBE9] rounded-2xl border border-[#E8EBE9] bg-[#FBFBF9] px-5"
      data-testid="invite-details"
    >
      {rows.map(([label, value, testId]) => (
        <Row key={testId} label={label} value={value} testId={testId} />
      ))}
    </dl>
  );
};
